import React, { Component,useState,useEffect } from 'react'
import FeatherIcon from 'feather-icons-react';
import { ShimmerThumbnail,ShimmerTable } from "react-shimmer-effects";
import { getUser, saveLastPage, titleClass, useTitle, useTitleClass } from '../functions/Reusables';
import axios from "axios";




export default class  ProcessingDashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoadingCards: true,
      isLoadingTable1: true,

      cardValues: {},
      table1Values: [],

    };
  }

    getCardData = async () => {
    const accessToken = getUser().access_token
    const headers ={
      'AccessToken':accessToken
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}dash/get_dashboard1/`,
        {headers})
        const dataList = response.data.data;
        const newMap = {}
        for (let index = 0; index < dataList.length; index++) {
          let key = Object.keys(dataList[index])[0]
          let value = Object.values(dataList[index])[0]
          newMap[key] = value
        }
        this.setState({
          cardValues: newMap,
          isLoadingCards:false
        });
    } catch (error) {
      console.log(error)
    }
  }

   getTableData1 = async () => {
    const accessToken = getUser().access_token
    const headers ={
      'AccessToken':accessToken
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}dispatch/get_dispatch/?_limit=5&_page=1`,
        {headers})
        
        const dataList = response.data.data;
        this.setState((state, props) => ({
          table1Values: dataList,
          isLoadingTable1:false
        }));
  
    } catch (error) {
      console.log(error)
    }
  }


  componentDidMount() {
    console.log("DASHBOARD MOUNTED")
    titleClass("Dashboard | AMAC Tenement")
    saveLastPage("dashboard")
    this.getCardData()
    this.getTableData1()
  }


  render() {
    return (
      <div>
        <div className="page-body">
          <div className="container-fluid dashboard-default-sec">
          <div class="page-header">
              <div class="row">
                <div class="col-sm-6">
                  <h3>Dashboard</h3>
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="index.html">Dashboard</a></li>
                  </ol>
                </div>
                
              </div>
            </div>
            <div className="row" style={{marginTop:'20px'}}>
              
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 box-col-12 des-xl-100 dashboard-sec">
                <div className="row">
                  
                  
                   
                  <div class="col-md-4 col-xl-4 col-lg-4">
                  {this.state.isLoadingCards ? <ShimmerThumbnail height={115} rounded /> :<div class="card o-hidden border-0">
                      <div class="bg-primary b-r-4 card-body">
                        <div class="media static-top-widget">
                          <div class="align-self-center text-center"><FeatherIcon icon="home"></FeatherIcon></div>
                          <div class="media-body"><span class="m-0">Properties</span>
                            <h4 class="mb-0 counter">{`${this.state.cardValues.total_prop}`}</h4><FeatherIcon class="icon-bg" icon="home"></FeatherIcon>
                          </div>
                        </div>
                      </div>
                    </div>}
                  </div>
                  <div class="col-md-4 col-xl-4 col-lg-4">
                  {this.state.isLoadingCards ? <ShimmerThumbnail height={115} rounded /> :<div class="card o-hidden border-0">
                      <div class="bg-secondary b-r-4 card-body" >
                        <div class="media static-top-widget">
                          <div class="align-self-center text-center"><FeatherIcon icon="home"></FeatherIcon></div>
                          <div class="media-body"><span class="m-0">AMAC 1</span>
                            <h4 class="mb-0 counter">{`${this.state.cardValues.amac1_prop}`}</h4><FeatherIcon class="icon-bg" icon="home"></FeatherIcon>
                          </div>
                        </div>
                      </div>
                    </div>}
                  </div>
                  <div class="col-md-4 col-xl-4 col-lg-4">
                  {this.state.isLoadingCards ? <ShimmerThumbnail height={115} rounded /> :<div class="card o-hidden border-0">
                      <div class="bg-secondary b-r-4 card-body" >
                        <div class="media static-top-widget">
                          <div class="align-self-center text-center"><FeatherIcon icon="home"></FeatherIcon></div>
                          <div class="media-body"><span class="m-0">AMAC 2</span>
                            <h4 class="mb-0 counter">{`${this.state.cardValues.amac2_prop}`}</h4><FeatherIcon class="icon-bg" icon="home"></FeatherIcon>
                          </div>
                        </div>
                      </div>
                    </div>}
                  </div>
                </div>
              </div>
              
              
              <div className="col-xl-13 box-col-12 des-xl-100">
                <div className="row">
                  <div className="col-xl-12 recent-order-sec">
                    <div className="card">
                      <div class="card-header pb-0">
                        <h5>Dispatch</h5>
                      </div>    
                      <div class="card-body pt-10">
                      <div class="table-responsive">
                        {this.state.isLoadingTable1 ? <ShimmerTable row={4} col={9} /> :<table class="table">
                          <thead>
                            <tr>
                              <th scope="col">PID</th>
                              <th scope="col">Dispatch Type</th>
                              <th scope="col">Date</th>
                              <th scope="col">Received By.</th>
                              <th scope="col">Dispatch Mode</th>
                            
                            </tr>
                          </thead>
                          <tbody>
                          {this.state.table1Values.map((items)=>
                                <tr>
                                  <th scope="row">{items.pid}</th>
                                  <td>{items.type}</td>
                                  <td>{items.date_delivered}</td>
                                  <td>{items.received_by}</td>
                                  <td>{items.mode}</td>

                                </tr>
                              )}
                            
                          </tbody>
                        </table>}
                      </div>
                      </div>
                      
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <footer className="footer">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 footer-copyright">
                <p className="mb-0">Copyright 2022 © AMAC All rights reserved.</p>
              </div>
              
            </div>
          </div>
        </footer>

    </div>
    )
  }
}
